<footer class="site-footer">
    <div class="site-container footer-certification-strip" aria-label="License, privacy, and client protection links">
        <span>Licensed Texas Professional Inspector · TREC# 23635</span>
        <span>Locally owned in Georgetown, Texas</span>
        <a routerLink="/privacy-policy">Privacy Policy</a>
        <a href="https://www.trec.texas.gov/forms/consumer-protection-notice" target="_blank"
            rel="noopener noreferrer">TREC Consumer Protection Notice</a>
    </div>
    <section class="site-container field-journal-footer-strip" aria-label="GTX family-owned inspection note">
        <img src="assets/images/design-a/kari-roland-door-field-journal.jpg" alt="Kari and Roland with GTX Inspections" loading="lazy" />
        <div>
            <span>GTX Inspections</span>
            <strong>Local Georgetown home inspections.</strong>
            <p>TREC# 23635 · (512) 848-1316 · moreno&#64;gtxinspections.com</p>
        </div>
        <nav aria-label="Design A footer links">
            <a routerLink="/contact">Schedule</a>
            <a routerLink="/privacy-policy">Privacy</a>
            <a href="https://www.trec.texas.gov/forms/consumer-protection-notice" target="_blank"
                rel="noopener noreferrer">TREC Notice</a>
        </nav>
    </section>
    <div class="site-container footer-checkup-panel" aria-label="GTX compliance and resource summary">
        <article *ngFor="let highlight of footerHighlights">
            <span>{{ highlight.label }}</span>
            <strong>{{ highlight.value }}</strong>
            <p>{{ highlight.note }}</p>
        </article>
        <a routerLink="/contact">Schedule with GTX</a>
    </div>
    <div class="site-container footer-grid">
        <div class="footer-brand">
            <img src="assets/images/logo.png" alt="GTX Inspections logo" />
            <p>
                GTX Inspections, LLC is a locally owned, licensed, and bonded home inspection company in
                Georgetown, Texas, built around careful inspection work, clear reports, and practical Central Texas inspection guidance.
            </p>
            <p class="footer-resource-note">
                Resources and provider contacts are shared as informational starting points and should be independently verified.
            </p>
            <div class="footer-badge-grid" aria-label="GTX business details">
                <span *ngFor="let badge of trustBadges">{{ badge }}</span>
            </div>
        </div>
        <div>
            <h2>Site</h2>
            <a routerLink="/">Home</a>
            <a routerLink="/inspection">Inspection Details</a>
            <a routerLink="/about">About Roland and Kari</a>
            <a routerLink="/resources">Resources</a>
            <a routerLink="/contact">Contact</a>
        </div>
        <div>
            <h2>Contact</h2>
            <a href="tel:512-848-1316">(512) 848-1316</a>
            <a href="mailto:moreno@gtxinspections.com">moreno&#64;gtxinspections.com</a>
            <a routerLink="/contact">Schedule an inspection</a>
            <p>Available Monday-Friday and Sunday, 8:00 am - 8:00 pm. Saturday closed.</p>
        </div>
        <div class="footer-compliance">
            <h2>Compliance</h2>
            <span class="footer-license">Professional Inspector TREC# 23635</span>
            <a routerLink="/privacy-policy">Privacy Policy</a>
            <a href="https://www.trec.texas.gov/forms/consumer-protection-notice" target="_blank"
                rel="noopener noreferrer">TREC Consumer Protection Notice</a>
            <a routerLink="/resources" fragment="resources-disclaimer">Referral / Resources Disclaimer</a>
            <p>Form details are used to respond to inspection requests and coordinate service.</p>
            <div class="footer-compliance-list" aria-label="Compliance summary">
                <span *ngFor="let note of complianceNotes">{{ note }}</span>
            </div>
        </div>
        <div class="footer-service-area">
            <h2>Service Area</h2>
            <p>Georgetown and surrounding Central Texas communities.</p>
            <div class="footer-chip-grid" aria-label="GTX service area">
                <span *ngFor="let area of serviceAreas">{{ area }}</span>
            </div>
        </div>
    </div>
    <div class="site-container footer-utility-row" aria-label="Compliance and quick links">
        <a routerLink="/privacy-policy">Privacy Policy</a>
        <a href="https://www.trec.texas.gov/forms/consumer-protection-notice" target="_blank"
            rel="noopener noreferrer">TREC Consumer Protection Notice</a>
        <a routerLink="/contact">Schedule an inspection</a>
        <a routerLink="/resources">Provider resources</a>
    </div>
    <div class="site-container footer-bottom">
        <span>Copyright &copy; {{ currentYear }} GTX Inspections, LLC. All Rights Reserved.</span>
        <span>Provider resources are informational, not endorsements, and should be independently verified.</span>
    </div>
</footer>
